import React, { useState } from 'react';
import { sendMail } from '../../helpers/sendMail';
import { useAntiBot } from '../../helpers/antiBot';
import HoneypotField from '../common/HoneypotField';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ContactsForm = () => {

  const { honeypotProps, getAntiBotPayload, looksLikeBot } = useAntiBot();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [position, setPosition] = useState('');
  const [projectDetails, setProjectDetails] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (setter) => (e) => {
    setter(e.target.value);
    if (alertMessage) setAlertMessage('');
    if (showSuccess) setShowSuccess(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (name === '' || email === '' || company === '' || position === '' || projectDetails === '') {
      setAlertMessage('Por favor complete todos los campos');
      setShowSuccess(false);
      return;
    }

    if (!EMAIL_REGEX.test(email)) {
      setAlertMessage('Por favor ingrese un correo válido');
      setShowSuccess(false);
      return;
    }

    setAlertMessage('');

    // Si parece un bot mostramos el mensaje de éxito sin enviar nada,
    // así no aprende qué lo delató.
    if (looksLikeBot()) {
      setName('');
      setEmail('');
      setCompany('');
      setPosition('');
      setProjectDetails('');
      setShowSuccess(true);
      return;
    }

    setIsSubmitting(true);

    const ok = await sendMail(
      email,
      name,
      company,
      position,
      projectDetails,
      getAntiBotPayload()
    );

    setIsSubmitting(false);

    if (ok) {
      setName('');
      setEmail('');
      setCompany('');
      setPosition('');
      setProjectDetails('');
      setShowSuccess(true);
    } else {
      setAlertMessage('No pudimos enviar tu mensaje. Por favor inténtalo nuevamente o escríbenos a proyectos@koding.cl');
    }
  };

  return (
    <>
      <div className='col-xl-5 col-lg-7 col-md-12 order-0 order-lg-1'>
        <div className='register-wrap p-5 bg-white shadow rounded-custom mt-5 mt-lg-0 mt-xl-0'>
          <h3 className='fw-medium h4'>
            Cuéntenos su proyecto y nos pondremos en contacto lo más pronto posible
          </h3>

          <form action='#' className='mt-4 register-form' onSubmit={handleSubmit}>
            <HoneypotField {...honeypotProps} />
            <div className='row'>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Nombre'
                    aria-label='name'
                    value={name}
                    onChange={handleChange(setName)}
                    disabled={isSubmitting}
                  />
                </div>
              </div>
              <div className='col-sm-6 '>
                <div className='input-group mb-3'>
                  <input
                    type='email'
                    className='form-control'
                    placeholder='Correo'
                    aria-label='email'
                    value={email}
                    onChange={handleChange(setEmail)}
                    disabled={isSubmitting}
                  />
                </div>
              </div>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Empresa'
                    aria-label='company-website'
                    value={company}
                    onChange={handleChange(setCompany)}
                    disabled={isSubmitting}
                  />
                </div>
              </div>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Cargo'
                    aria-label='work-Email'
                    value={position}
                    onChange={handleChange(setPosition)}
                    disabled={isSubmitting}
                  />
                </div>
              </div>
              <div className='col-12'>
                <div className='input-group mb-3'>
                  <textarea
                    className='form-control'
                    placeholder='Cuéntanos sobre tu proyecto'
                    style={{ height: '120px' }}
                    value={projectDetails}
                    onChange={handleChange(setProjectDetails)}
                    disabled={isSubmitting}
                  ></textarea>
                </div>
              </div>
              <div className='col-12'>
                {alertMessage && (
                  <div className='alert alert-danger' role='alert'>
                    {alertMessage}
                  </div>
                )}
              </div>
              <div className='col-12'>
                <button
                  type='submit'
                  className='btn btn-primary mt-4 d-block w-100'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
              <div className='col-12 mt-4'>
                {showSuccess && (
                  <div className='alert alert-success' role='alert'>
                    Muchas gracias, pronto estaremos en contacto
                  </div>
                )}
              </div>
              <div className='col-12 mt-5'>
                <p className='text-primary'><i className='fas fa-envelope'></i> También puede escribirnos a <a href='mailto:proyectos@koding.cl'>proyectos@koding.cl</a></p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactsForm;
